import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import SEO from '@/components/SEO';
import { LudopediaIntegration } from '@/components/integrations/LudopediaIntegration';

const IntegrationsPage: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('ludopedia_connected') === 'true') {
      toast.success('Conta Ludopedia conectada com sucesso!');
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  return (
    <>
      <SEO title="Integrações" description="Conecte sua conta Boardverso com outros serviços." />
      <div className="container mx-auto px-4 py-8 bg-gray-100 dark:bg-gray-900">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-center text-gray-800 dark:text-gray-100">
            Integrações de Contas
          </h1>
          <p className="text-gray-600 dark:text-gray-300 mt-2 text-center">
            Conecte suas contas de outras plataformas para aprimorar sua experiência no Boardverso.
          </p>
        </header>
        
        <section className="max-w-2xl mx-auto">
          <LudopediaIntegration />
          {/* Adicionar mais seções de integração aqui */}
        </section>
      </div>
    </>
  );
};

export default IntegrationsPage; 